module.exports = __webpack_public_path__ + "static/media/cry.0ca8e636.svg";